// ТРИ ЗАГОЛОВКА СТАТЬИ СПРАВКИ — ОДНА ФУНКЦИЯ НА ВЕСЬ ПРОДУКТ (ТЗ HELP-ARTICLE-UNIFY §2, владелец 25.10.2026:
// «заголовков три: супер-короткий — шапка окна, средний — список, длинный — в начале текста; так должно быть
// везде»). Её зовут статья сайта (HelpArticle), серверная страница статьи приложения (app-pages/help.ts),
// списки справки и «поделиться». Других мест выбора заголовка нет — запасок вроде «Как это работает» тоже.
// Поля статьи — фронтматтер (help-content.ts): `short` (очень короткий), `title` (средний), `heading` (длинный).

export interface HelpTitleSource {
  title: string;
  heading?: string | null;
  short?: string | null;
}

export interface HelpTitles {
  /** Шапка окна/страницы статьи между «×» и «поделиться». */
  bar: string;
  /** Строка списка статей, текст «поделиться». */
  list: string;
  /** Большой заголовок первой строкой текста. */
  h1: string;
}

export function articleTitles(a: HelpTitleSource): HelpTitles {
  const list = a.title.trim();
  return {
    bar: a.short?.trim() || list,
    list,
    h1: a.heading?.trim() || list,
  };
}
